module.exports = __webpack_public_path__ + "img/menu-report-forms.bb6a00b2.svg";